import TooltipSyncButton from './TooltipButton';

export default TooltipSyncButton;
